import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { FontIcon } from "react-md";

class SpecialAttentionNotes extends React.Component {
  render() {
    const { text, className } = this.props;
    return (
      <MCard
        title="Special Attention Notes"
        className={className}
        fields={[
          {
            key: "special-attention-notes",
            control: (
              <div
                style={{
                  verticalAlign: "top",
                  display: "inline-flex",
                  width: "calc(100% - 32px)"
                }}
              >
                <FontIcon style={{ marginRight: "0.5em" }} title="Comments">
                  comment
                </FontIcon>
                <div style={{ overflowWrap: "break-word", width: "100%" }}>
                  {text.split("<br />").map(function(item, index) {
                    return (
                      <span key={item + index}>
                        {item}
                        <br />
                      </span>
                    );
                  })}
                </div>
              </div>
            )
          }
        ]}
      />
    );
  }
}

SpecialAttentionNotes.defaultProps = {
  text: ""
};

SpecialAttentionNotes.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
};

export default SpecialAttentionNotes;
